import revive_payload_client_4sVQNw7RlN from "/home/runner/work/web/web/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/runner/work/web/web/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/runner/work/web/web/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import debug_hAQZccAnsC from "/home/runner/work/web/web/node_modules/nuxt/dist/app/plugins/debug.js";
import payload_client_yVLowv6hDl from "/home/runner/work/web/web/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/runner/work/web/web/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/runner/work/web/web/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/home/runner/work/web/web/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/home/runner/work/web/web/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/runner/work/web/web/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_client_OVoKJro5pc from "/home/runner/work/web/web/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.js";
import switch_locale_path_ssr_5csfIgkrBP from "/home/runner/work/web/web/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/home/runner/work/web/web/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import primevue_plugin_egKpok8Auk from "/home/runner/work/web/web/.nuxt/primevue-plugin.mjs";
import plugin_client_XxbS7tGyhp from "/home/runner/work/web/web/node_modules/@primevue/nuxt-module/dist/runtime/plugin.client.js";
import axios_sVCuMR6hEC from "/home/runner/work/web/web/plugins/axios.js";
import dayjs_FoMn5Zigri from "/home/runner/work/web/web/plugins/dayjs.js";
import pinia_Uphuq97G1L from "/home/runner/work/web/web/plugins/pinia.js";
import i18n_sVHQBgnb3t from "/home/runner/work/web/web/plugins/i18n.js";
import fetchGlobals_client_rrCiDGYqsV from "/home/runner/work/web/web/plugins/fetchGlobals.client.js";
import splide_53VANfVk1b from "/home/runner/work/web/web/plugins/splide.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  debug_hAQZccAnsC,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_client_OVoKJro5pc,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  primevue_plugin_egKpok8Auk,
  plugin_client_XxbS7tGyhp,
  axios_sVCuMR6hEC,
  dayjs_FoMn5Zigri,
  pinia_Uphuq97G1L,
  i18n_sVHQBgnb3t,
  fetchGlobals_client_rrCiDGYqsV,
  splide_53VANfVk1b
]